var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsSorticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.902,
    height: 13.039,
    viewBox: "0 0 14.902 13.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort-amount-down",
    "data-name": "Icon awesome-sort-amount-down",
    d: "M8.848,13.426H6.985a.466.466,0,0,0-.466.466v.931a.466.466,0,0,0,.466.466H8.848a.466.466,0,0,0,.466-.466v-.931A.466.466,0,0,0,8.848,13.426ZM5.122,11.564h-1.4V2.716A.466.466,0,0,0,3.26,2.25H2.328a.466.466,0,0,0-.466.466v8.848H.466a.466.466,0,0,0-.329.795l2.328,2.794a.466.466,0,0,0,.658,0l2.328-2.794A.466.466,0,0,0,5.122,11.564Zm7.451-5.588H6.985a.466.466,0,0,0-.466.466v.931a.466.466,0,0,0,.466.466h5.588a.466.466,0,0,0,.466-.466V6.441A.466.466,0,0,0,12.573,5.975ZM10.711,9.7H6.985a.466.466,0,0,0-.466.466V11.1a.466.466,0,0,0,.466.466h3.725a.466.466,0,0,0,.466-.466v-.931A.466.466,0,0,0,10.711,9.7ZM14.436,2.25H6.985a.466.466,0,0,0-.466.466v.931a.466.466,0,0,0,.466.466h7.451a.466.466,0,0,0,.466-.466V2.716A.466.466,0,0,0,14.436,2.25Z",
    transform: "translate(0 -2.25)",
    fill: "#a7a7a7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsSorticon);
export default __webpack_public_path__ + "static/media/forum-details-sorticon.6f6e0e7789367f06690b04c549709bc1.svg";
export { ForwardRef as ReactComponent };